import { GeneroOutros } from 'src/tipos'

export const SELECT_GENEROOUTROS = Object.keys(GeneroOutros).map(item => ({
  id: item,
  texto: GeneroOutros[item as keyof typeof GeneroOutros]
}))
